export const kindleDownloadMethods = {
	sendToEmail: 1,
	sendToKindle: 2,
};
